import { useState, useEffect, useRef } from "react";
import { Form, FormGroup, Input, Button } from "reactstrap";
import { useSearchParams } from "react-router-dom";
import ADHDTemplate from "./ADHDTemplate";
import ASDTemplate from "./ASDTemplate";
import { getSinglePatientAction } from "../../../Api/patient";
import moment from "moment"
import { generateReportAPI, updateReport } from "../../../Api/report";
import GeneratingLoader from "../../../CommonElements/GeneratingLoader/GeneratingLoader";
import { useNavigate } from "react-router-dom";
import { uploadLogo } from "../../../Api/report";
import { saveReport } from "../../../Api/report";
import { getReportData } from "../../../Api/report";
import { getImage } from "../../../Api/report";
import { generateSummary } from "../../../Api/report";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import { toast } from "react-toastify";
import { uploadDocumentAPI, fetchPatientDocuments, deleteDocumentAPI } from "../../../Api/report";
import { getIndividualPatientDoc } from "../../../Api/patient";

const GenerateDoc = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useAppSelector(state => state.user)
  const [rewriteStatus, setRewriteStatus] = useState(false)
  const patient_id = searchParams.get("patient_id") || "";
  const report_Id = searchParams.get("from") || "";
  const [template, setTemplate] = useState("adhd");
  const [patient, setPatient] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const [asdContent, setAsdContent] = useState<any>({
    dateSeen: ""
  })
  const [adhdContent, setAdhdContent] = useState<any>({
    basic: ``,
    typeSelect: "F314.01 (F90.2) ADHD, Combined Presentation",
    severity: "Mild",
    dsmCreterionA: "Met",
    dsmCreterionA2: "Met",
    dsmCreterionBCD: "Met",
    docName: "",
    dateSeen: ""
  })

  const [logoUploaded, setLogoUploaded] = useState(false)
  const [logoUrl, setLogoUrl] = useState<any>("")
  const [logoDimensions, setLogoDimensions] = useState({ width: 0, height: 0 });
  const [signDimensions, setSignDimensions] = useState({ width: 0, height: 0 });
  const [signUploaded, setSignUploaded] = useState(false)
  const [signUrl, setSignUrl] = useState<any>("");
  const [logoFile, setLogoFile] = useState<any>(null);
  const [signFile, setSignFile] = useState<any>(null);
  const [copyStatus, setCopyStatus] = useState(false);
  const [reportId, setReportId] = useState("")
  const [documents, setDocuments] = useState<any>([]);

  const fetchPatientDetails = async () => {

    try {
      const response = await getSinglePatientAction(patient_id);
      if (response.status === "success") {
        setPatient(response.payload.payload);
      } else {
        console.error("Failed to fetch patient details:", response.message);
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  useEffect(() => {
    if (patient) {
      let basicText = `${patient.firstname} ${patient.lastname} was assessed by me on the ${moment().format("Do MMMM YYYY")} attendance with`
      setAdhdContent((prev: any) => ({
        ...prev,
        ["basic"]: basicText
      }));
    }
  }, [patient])

  const fetchReportData = async () => {
    const response: any = await getReportData({ report_id: report_Id })
    setTemplate(response.data.type)
    if (response?.data?.type === "adhd") {
      setAdhdContent(response.data.content)
    } else if (response.data.type === "asd") {
      setAsdContent(response.data.content)
    }

    const getImages = []
    if (response?.data.content.logoId) {
      getImages.push(getImage({ imageId: response?.data.content.logoId }))
    }
    if (response?.data.content.signId) {
      getImages.push(getImage({ imageId: response?.data.content.signId }))
    }

    if (getImages.length > 0) {
      let results = await Promise.all(getImages);
      if (results.length && results[0]) {
        const logoData: any = results.filter((item: any) => item.type === "logo")[0]
        const signData: any = results.filter((item: any) => item.type === "sign")[0]
        if (logoData) {
          setLogoUrl(logoData.imageUrl)
          setLogoUploaded(true)
          setLogoDimensions({ width: logoData.width, height: logoData.height })
        }
        if (signData) {
          setSignUrl(signData.imageUrl)
          setSignUploaded(true)
          setSignDimensions({ width: signData.width, height: signData.height })
        }
      }
    }
  }

  const handleGenerateSummary = async (patientId: any) => {
    setLoader(true)
    const response: any = await generateSummary({ patientId: patientId })
    if (response.data.status === "success") {
      setAsdContent((prev: any) => ({
        ...prev,
        ["reportSummary"]: response.data.summary.replaceAll(/[*#]/g, '') || ""
      }));
      setAdhdContent((prev: any) => ({
        ...prev,
        ["reportSummary"]: response.data.summary.replaceAll(/[*#]/g, '') || ""
      }));
      setLoader(false);
    } else {
      console.error("Failed to fetch patient details:", response.message);
    }
  }

  const loadDocuments = async () => {
    try {
      const docs: any[] = await fetchPatientDocuments(patient_id);

      setDocuments(docs);
    } catch (err) {
      console.error("Error loader documents");
    }
  };

  const getDraftContent = async () => {
    const _rewriteStatus = localStorage.getItem("rewriteStatus") === "true" ? true : false;
    setRewriteStatus(_rewriteStatus)


    const _draftContent = JSON.parse(localStorage.getItem("draftContent") || "")

    const _contentType = localStorage.getItem("draftType") || ""
    setTemplate(_contentType)
    if (_contentType === "adhd") {
      setAdhdContent(_draftContent)
    } else if (_contentType === "asd") {
      setAsdContent(_draftContent)
    }

    const getImages = []
    if (_draftContent.logoId) {
      getImages.push(getImage({ imageId: _draftContent.logoId }))
    }
    if (_draftContent.signId) {
      getImages.push(getImage({ imageId: _draftContent.signId }))
    }

    if (getImages.length > 0) {
      let results = await Promise.all(getImages);
      if (results.length && results[0]) {
        const logoData: any = results.filter((item: any) => item.type === "logo")[0]
        const signData: any = results.filter((item: any) => item.type === "sign")[0]
        if (logoData) {
          setLogoUrl(logoData.imageUrl)
          setLogoUploaded(true)
          setLogoDimensions({ width: logoData.width, height: logoData.height })
        }
        if (signData) {
          setSignUrl(signData.imageUrl)
          setSignUploaded(true)
          setSignDimensions({ width: signData.width, height: signData.height })
        }
      }
    }
  }

  useEffect(() => {
    if (patient_id) {
      fetchPatientDetails();
      // handleGenerateSummary(patient_id)'pointer' :
      loadDocuments()
    }
    if (report_Id !== "") {
      fetchReportData()
      setRewriteStatus(true)
      setCopyStatus(true)
      setReportId(report_Id)
    }
    else {
      if (!copyStatus) {
        const draftPatient = localStorage.getItem("draftPatient")
        if (patient_id === draftPatient) {
          getDraftContent()
        }
      }
    }
  }, [patient_id]);

  useEffect(() => {
    if (!copyStatus) {
      if (asdContent.asdCurrentHistory) {
        localStorage.setItem("draftContent", JSON.stringify(asdContent))
        localStorage.setItem("draftPatient", patient_id)
        localStorage.setItem("draftType", "asd")
        localStorage.setItem("rewriteStatus", rewriteStatus.toString())
      }
      if (adhdContent.specificHistory) {
        localStorage.setItem("draftContent", JSON.stringify(adhdContent))
        localStorage.setItem("draftPatient", patient_id)
        localStorage.setItem("draftType", "adhd")
        localStorage.setItem("rewriteStatus", rewriteStatus.toString())
      }
    }
  }, [asdContent, adhdContent])

  const generateReport = async () => {
    setLoader(true)

    const uploadPromises = [];

    if (logoFile) {
      const logoFormData = new FormData();
      logoFormData.append("file", logoFile);
      logoFormData.append("fileType", "logo");
      logoFormData.append("fileWidth", `${logoDimensions.width}`);
      logoFormData.append("fileHeight", `${logoDimensions.height}`);

      uploadPromises.push(uploadLogo(logoFormData))
    }

    if (signFile) {
      const signFormData = new FormData();
      signFormData.append("file", signFile);
      signFormData.append("fileType", "sign");
      signFormData.append("fileWidth", `${signDimensions.width}`);
      signFormData.append("fileHeight", `${signDimensions.height}`);

      uploadPromises.push(uploadLogo(signFormData))
    }

    let results: any = []
    if (uploadPromises.length > 0) {
      results = await Promise.all(uploadPromises);
    }
    const content = template === "asd" ? asdContent : adhdContent
    const reportInfo = {
      template: template,
      content: content,
      patientId: patient_id,
      logoId: results?.filter((result: any) => result.data.type === "logo")[0]?.data.fileId || content.logoId,
      signId: results?.filter((result: any) => result.data.type === "sign")[0]?.data.fileId || content.signId,
    }

    const response: any = await generateReportAPI(reportInfo)
    if (response.data.status) {
      setLoader(false)
      setRewriteStatus(true)
      if (template === "asd") {
        setAsdContent(response.data.payload.content)
      } else {
        setAdhdContent(response.data.payload.content)
      }
    }
  }

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAdhdContent((prev: any) => ({
      ...prev,
      [name]: value
    }));
  }

  const handleASDChange = (e: any) => {
    const { name, value } = e;
    setAsdContent((prev: any) => ({
      ...prev,
      [name]: value
    }));
  }

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);

      const img = new Image();
      img.src = imageUrl;
      img.onload = async () => {
        const imageLayerRate = img.width / img.height;
        const dropZoneRate = 250 / 80;
        let idealWidth = 0;
        let idealHeight = 0;
        if (imageLayerRate > dropZoneRate) {
          idealWidth = 250;
          idealHeight = img.height * 250 / img.width
        } else {
          idealWidth = img.width * 80 / img.height;
          idealHeight = 80
        }
        if (type === "logo") {
          setLogoUrl(imageUrl)
          setLogoDimensions({ width: idealWidth, height: idealHeight })
          setLogoFile(file)
          setLogoUploaded(true)
        } else {
          setSignUrl(imageUrl)
          setSignDimensions({ width: idealWidth, height: idealHeight })
          setSignFile(file)
          setSignUploaded(true)
        }
      };
    }
  }

  const goToPreview = async () => {
    if (copyStatus === false) {
      const response: any = await saveReport({
        content: template === "asd" ? asdContent : adhdContent,
        patientId: patient_id,
        template: template,
      })
      localStorage.removeItem("draftContent")
      localStorage.removeItem("draftPatient")
      localStorage.removeItem("draftType")
      localStorage.removeItem("rewriteStatus")
      if (response.status) {
        navigate(`/patient/report_generate/${response.data.payload.report_id}/preview`)
      }
    } else {
      const uploadPromises = [];

      if (logoFile) {
        const logoFormData = new FormData();
        logoFormData.append("file", logoFile);
        logoFormData.append("fileType", "logo");
        logoFormData.append("fileWidth", `${logoDimensions.width}`);
        logoFormData.append("fileHeight", `${logoDimensions.height}`);

        uploadPromises.push(uploadLogo(logoFormData))
      }

      if (signFile) {
        const signFormData = new FormData();
        signFormData.append("file", signFile);
        signFormData.append("fileType", "sign");
        signFormData.append("fileWidth", `${signDimensions.width}`);
        signFormData.append("fileHeight", `${signDimensions.height}`);

        uploadPromises.push(uploadLogo(signFormData))
      }

      let results
      if (uploadPromises.length > 0) {
        results = await Promise.all(uploadPromises);
      }
      let logoId = results?.filter((result: any) => result.data.type === "logo")[0]?.data.fileId
      let signId = results?.filter((result: any) => result.data.type === "sign")[0]?.data.fileId

      if (template === "asd") {
        if (logoId) asdContent.logoId = logoId || "";
        if (signId) asdContent.signId = signId || "";

      } else {
        if (logoId) adhdContent.logoId = logoId || "";
        if (signId) adhdContent.signId = signId || "";
      }
      const response: any = await updateReport({
        content: template === "asd" ? asdContent : adhdContent,
        reportId: reportId,
        template: template
      })
      navigate(`/patient/report_generate/${response.data.payload.report_id}/preview`)
    }
  }

  const onlySaveReport = async () => {
    if (copyStatus === false) {
      const response: any = await saveReport({
        content: template === "asd" ? asdContent : adhdContent,
        patientId: patient_id,
        template: template,
      })
      localStorage.removeItem("draftContent")
      localStorage.removeItem("draftPatient")
      localStorage.removeItem("draftType")
      localStorage.removeItem("rewriteStatus")
      setReportId(response.data.payload.report_id)
      setCopyStatus(true)
      toast.success("Your report has been saved. You can preview it now.")
    } else {
      const uploadPromises = [];

      if (logoFile) {
        const logoFormData = new FormData();
        logoFormData.append("file", logoFile);
        logoFormData.append("fileType", "logo");
        logoFormData.append("fileWidth", `${logoDimensions.width}`);
        logoFormData.append("fileHeight", `${logoDimensions.height}`);

        uploadPromises.push(uploadLogo(logoFormData))
      }

      if (signFile) {
        const signFormData = new FormData();
        signFormData.append("file", signFile);
        signFormData.append("fileType", "sign");
        signFormData.append("fileWidth", `${signDimensions.width}`);
        signFormData.append("fileHeight", `${signDimensions.height}`);

        uploadPromises.push(uploadLogo(signFormData))
      }

      let results
      if (uploadPromises.length > 0) {
        results = await Promise.all(uploadPromises);
      }
      let logoId = results?.filter((result: any) => result.data.type === "logo")[0]?.data.fileId
      let signId = results?.filter((result: any) => result.data.type === "sign")[0]?.data.fileId

      if (template === "asd") {
        if (logoId) asdContent.logoId = logoId || "";
        if (signId) asdContent.signId = signId || "";

      } else {
        if (logoId) adhdContent.logoId = logoId || "";
        if (signId) adhdContent.signId = signId || "";
      }
      await updateReport({
        content: template === "asd" ? asdContent : adhdContent,
        reportId: reportId,
        template: template
      })
      toast.success("Your report has been saved. You can preview it now.")
    }
  }

  // Upload documents
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoader(true)
    const files = event.target.files;
    if (!files || files.length === 0) {
      setLoader(false)
      return;
    }
    if (files.length + documents.length > 4) {
      toast.error("You can upload maximum 4 documents")
      setLoader(false)
      return;
    }
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("file[]", file);
    });

    // Add patient ID to the form data
    formData.append("patientId", patient_id);

    try {
      const response = await uploadDocumentAPI(formData);
      if (response?.data.status === "success") {
        setLoader(false)
        toast.success("Documents uploaded")
        loadDocuments()
        setAdhdContent((prev: any) => ({
          ...prev,
          ["reportSummary"]: ""
        }));
        setAsdContent((prev: any) => ({
          ...prev,
          ["reportSummary"]: ""
        }));
      } else {
        setLoader(false)
        toast.error("Upload failed ❌");
      }
    } catch (error) {
      setLoader(false)
      alert("Error uploading file. Check console.");
      console.error(error);
    }
  };

  const handleDeleteDoc = async (document: any) => {
    setLoader(true)
    const response: any = await deleteDocumentAPI({ doc_id: document.id })
    if (response.data.status === "success") {
      setLoader(false)
      loadDocuments()
      setAdhdContent((prev: any) => ({
        ...prev,
        ["reportSummary"]: ""
      }));
      setAsdContent((prev: any) => ({
        ...prev,
        ["reportSummary"]: ""
      }));
      toast.success(response.data.message)
    }
  }

  const handleClickDoc = async (documentID: any) => {
    const response: any = await getIndividualPatientDoc(documentID)
    if (response.status !== 200) {
      throw new Error("PDF not found");
    }

    // response.data is the Blob
    const blob = response.data;
    const blobUrl = URL.createObjectURL(blob);

    // Open in new tab
    window.open(blobUrl, "_blank");
  }

  return (
    <div className="page-body">
      {loader && <GeneratingLoader label="Loading..." />}
      <div className="" style={{ maxWidth: "1024px", margin: "0px auto", paddingBottom: "30px" }}>
        <Form className="theme-form d-flex flex-column flex-grow-1" onSubmit={generateReport}>
          <div className="d-flex align-items-center justify-content-end gap-4" style={{ width: "100%" }}>
            <FormGroup style={{ width: "30%" }}>
              <Input
                type="select"
                className="w-100"
                required
                name="template"
                value={template}
                onChange={(event) => setTemplate(event.target.value)}
              >
                <option value="adhd">ADHD Template</option>
                <option value="asd">ASD Template</option>
              </Input>
            </FormGroup>

            {
              rewriteStatus === true &&
              <>
                <FormGroup className="mb-0 form-sub-title d-flex justify-content-end">
                  <div className="text-end" style={{ width: "120px" }}>
                    <Button color="secondary" block style={{ padding: "12px 0px" }} onClick={goToPreview}>
                      {"Go to Preview"}
                    </Button>
                  </div>
                </FormGroup>

                <FormGroup className="mb-0 form-sub-title d-flex justify-content-end">
                  <div className="text-end" style={{ width: "120px" }}>
                    <Button color="primary" block style={{ padding: "12px 0px" }} onClick={onlySaveReport}>
                      Save
                    </Button>
                  </div>
                </FormGroup>
              </>
            }
            <FormGroup className="mb-0 form-sub-title d-flex justify-content-end">
              <div className="text-end" style={{ width: "120px" }}>
                <Button color="primary" block style={{ padding: "12px 0px" }} onClick={generateReport}>
                  {
                    rewriteStatus === true ? <>Regenerate</> : <>Generate</>
                  }
                </Button>
              </div>
            </FormGroup>
          </div>
        </Form>
        <div className="bg-white mt-3 py-3 px-5 rounded-2 templateBox">
          {
            template === "adhd" && <ADHDTemplate
              fullName={`${user.firstname} ${user.lastname}`}
              onChange={(e: any) => handleChange(e)}
              adhdContent={adhdContent}
              handleUpload={handleUpload}
              logoUploaded={logoUploaded}
              logoUrl={logoUrl}
              logoDimensions={logoDimensions}
              signDimensions={signDimensions}
              signUploaded={signUploaded}
              signUrl={signUrl}
              rewriteStatus={rewriteStatus}
              patient={patient}
              generateSummary={() => handleGenerateSummary(patient_id)}
              handleFileChange={handleFileChange}
              handleDeleteDoc={handleDeleteDoc}
              handleClickDoc={handleClickDoc}
              documents={documents}
            />
          }
          {
            template === "asd" && <ASDTemplate
              onASDChange={(e: any) => handleASDChange(e)}
              asdContent={asdContent}
              fullName={`${user.firstname} ${user.lastname}`}
              handleUpload={handleUpload}
              logoUploaded={logoUploaded}
              logoUrl={logoUrl}
              logoDimensions={logoDimensions}
              signDimensions={signDimensions}
              signUploaded={signUploaded}
              signUrl={signUrl}
              rewriteStatus={rewriteStatus}
              patient={patient}
              generateSummary={() => handleGenerateSummary(patient_id)}
              handleFileChange={handleFileChange}
              handleDeleteDoc={handleDeleteDoc}
              handleClickDoc={handleClickDoc}
              documents={documents}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default GenerateDoc